import * as QuotaApi from '@wix/ambassador-innovation-assistant-v2-quota/http';

import { PanoramaTransactions } from '../../panoramaTransactions';
import { reportPanoramaError } from '../../utils/toPanoramaError';
import { createAppAsyncThunk } from '../createAppAsyncThunk';

import { toConversationsQuota } from './model';
import { shouldLoad as selectShouldLoad } from './conversationsQuotaSelectors';

export const getConversationsQuota = createAppAsyncThunk(
  'chat/getConversationsQuota',
  async (_, { extra: { httpClient: client, panorama } }) => {
    const transaction = panorama.transaction(
      PanoramaTransactions.GET_CONVERSATIONS_QUOTA,
    );
    transaction.start();

    try {
      const {
        data: { quota },
      } = await client.request(QuotaApi.getQuota({}));
      transaction.finish();

      return toConversationsQuota({
        quota: quota?.conversations?.limit,
        current: quota?.conversations?.used,
        available: quota?.conversations?.available,
      });
    } catch (error) {
      reportPanoramaError(panorama, error, {
        feature: 'conversationsQuota',
        action: 'getConversationsQuota',
      });
      throw error;
    }
  },
);

export const getConversationsQuotaThrottled = createAppAsyncThunk(
  'chat/getConversationsQuota/throttled',
  (_, { dispatch, getState }) => {
    const shouldLoad = selectShouldLoad(getState());

    if (shouldLoad) {
      return dispatch(getConversationsQuota());
    }
  },
);
